import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const ShowMoreLess = ({
  expanded,
  setExpanded,
  className = undefined,
  ...props
}) => {
  const classes = useStyles()

  const toggle = React.useCallback(() => {
    setExpanded(old => !old)
  }, [setExpanded])

  return (
    <div onClick={toggle} className={clsx(classes.root, className)} {...props}>
      Show {expanded ? 'less' : 'more'}
    </div>
  )
}

export default ShowMoreLess
